define('../src/sublayouts/m5-section-title/m5-section-title',['jquery'], function($) {

    'use strict';

    var M5_SECTIONTITLE = function($component) {

        this.$component = $component;

        return this;
    };


    M5_SECTIONTITLE.prototype.init = function() {
        var _this = this,
            downloadTrigger = _this.$component.find('.m5-section-titletext-download');

            downloadTrigger.on('click',function(){
                if($(window).width() < 1025){
                    var wrapper = $(this).closest('.download-wrapper');
                    if(!wrapper.hasClass('hover-down')){
                        wrapper.addClass('hover-down')
                    }else{
                        wrapper.removeClass('hover-down')
                    }
                }
            })
    };

    return M5_SECTIONTITLE;
});


